import { Role } from "api/model/Roles";

export interface UserAddress {
    postalCode?: string;
    state?: string;
    street?: string;
    neighborhood?: string;
    number?: number;
    complement?: string;
}

export interface UserPrivateInfo {
    email: string;
    birthDate?: Date | null;
    phoneNumber?: string;
    address?: UserAddress;
    tempPassword?: string;
    welcomeEmail: boolean;
}

export interface UserDriverInfo {
    iracingId?: string;
    preferredNumbers?: {
        option1?: number;
        option2?: number;
        option3?: number;
    };
    teamId?: string;
    biography?: string;
    facebook?: string;
    instagram?: string;
    twitch?: string;
    website?: string;
}

export interface UserProfile {
    id?: string;
    firstName: string;
    lastName: string;
    displayName: string;
    initials?: string;
    country?: string | null;
    driverInfo?: UserDriverInfo;
}

export interface User extends UserProfile {
    privateInfo: UserPrivateInfo;
    roles: Role[];
}

export interface LoggedUser extends User {
    isLoaded: boolean;
    customClaims: CustomClaims;
    isAdmin: boolean;
}

export interface CustomClaims {
    valid: boolean;
    emailVerified: boolean;
    lastLoginAt: string;
}

export const UserProfileDefault: UserProfile = {
    firstName: "",
    lastName: "",
    displayName: "",
    initials: "",
    country: "",
    driverInfo: {
        iracingId: "",
        teamId: "",
        preferredNumbers: {
            option1: 0,
            option2: 0,
            option3: 0,
        },
        biography: "",
        facebook: "",
        instagram: "",
        twitch: "",
        website: "",
    },
};

export const UserPrivateInfoDefault: UserPrivateInfo = {
    email: "",
    birthDate: null,
    phoneNumber: "",
    address: {
        neighborhood: "",
        number: 0,
        postalCode: "",
        state: "",
        street: "",
        complement: "",
    },
    welcomeEmail: false,
    tempPassword: "",
};

export const UserDefault: User = {
    ...UserProfileDefault,
    privateInfo: { ...UserPrivateInfoDefault },
    roles: [],
};

export const LoggedUserDefault: LoggedUser = {
    ...UserDefault,
    isLoaded: false,
    customClaims: {
        emailVerified: false,
        valid: false,
        lastLoginAt: "",
    },
    isAdmin: false,
};
